import {useAppStore, useUserStore} from '@/stores'
import {useMeetingStore} from '@/stores'
import {useRecordingStore} from '@/stores'
import {useStreamStore} from '@/stores/streamStore'
import {useSnapshot} from '@/composables/useSnapshot'
import {mediator} from '@communication'
import {useEventBus} from '@vueuse/core'
import {useRecording} from './useRecording'

export const useDestroyCallback = () => {
  const {destroy} = useDestroy()

  useEventBus('session:participant:disjoined').on((event: any) => {
    const {party, isAlreadyDisJoined} = event
    if (party === 'assistant' && isAlreadyDisJoined) {
      destroy()
    }
  })
}

export const useDestroy = () => {
  const {stop: stopRecording} = useRecording()
  const {waitForFullImage, dismiss} = useSnapshot()

  const destroy = async () => {
    // todo: add flag isDestroying...
    const app = useAppStore()
    const user = useUserStore()
    const streamStore = useStreamStore()
    // A failed save must not skip the disjoin below, or the others are never told the session ended
    try {
      if (useRecordingStore().isOn && user.party === 'assistant') {
        await stopRecording()
      }
    } catch (error) {
      console.error('[destroy] stopping the recording before disjoin failed', error)
    }
    try {
      // Give the full image a short moment, so the save does not store the low-quality placeholder
      if (useMeetingStore().isDraw) {
        await waitForFullImage('snapshot', 10000)
        useEventBus('board:signal:snapshot:save')
        await dismiss('snapshot')
      }
    } catch (error) {
      console.error('[destroy] saving the snapshot before disjoin failed', error)
    }
    mediator.destroy()
    user.disjoin()
    streamStore.stopAll()
    app.goToEnd()
    // todo: specify exit transition
    setTimeout(() => {
      app.loaded()
    }, 2000)
  }

  const silentlyDestroy = async () => {
    // todo: add flag isDestroying...
    const user = useUserStore()
    const streamStore = useStreamStore()
    if (useRecordingStore().isOn && user.party === 'assistant') {
      stopRecording()
    }
    mediator.destroy()
    user.disjoin()
    streamStore.stopAll()
  }

  return {destroy, silentlyDestroy}
}
